import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Store for Atlas Advisor suggested-questions context.
 * Tracks both URL params (tab, subtab) and DynamoDB full names (tabFullName, subTabFullName)
 * so the exact mapping is available without prop drilling.
 */

export interface AdvisorSuggestedQuestionsContext {
  tab: string | null;
  subtab: string | null;
  tabFullName: string | null;
  subTabFullName: string | null;
  entityType: string | null;
}

export interface AdvisorSuggestedQuestionsState extends AdvisorSuggestedQuestionsContext {
  setContext: (ctx: AdvisorSuggestedQuestionsContext) => void;
}

export const useAdvisorSuggestedQuestionsStore = create<AdvisorSuggestedQuestionsState>()(
  devtools(
    (set) => ({
      tab: null,
      subtab: null,
      tabFullName: null,
      subTabFullName: null,
      entityType: null,
      setContext: (ctx) =>
        set(
          {
            tab: ctx.tab,
            subtab: ctx.subtab,
            tabFullName: ctx.tabFullName,
            subTabFullName: ctx.subTabFullName,
            entityType: ctx.entityType
          },
          false,
          'setContext'
        )
    }),
    { name: 'AdvisorSuggestedQuestions' }
  )
);
